export default "__VITE_ASSET__CSvBc5pV__"